import { createSlice } from '@reduxjs/toolkit';

import { getQuestionTree } from 'api/clinicalPolicyAPI';
import { handleError } from 'services/Error';

export const questionSlice = createSlice({
    name: 'question',
    initialState: {
        nodes: undefined,
    },
    reducers: {
        updateQuestionTree(state, action) {
            const { nodes } = action.payload;
            return { ...state, nodes };
        },
    },
});

export const { updateQuestionTree } = questionSlice.actions;

export const resetQuestionTree = () => (dispatch) => {
    dispatch(
        updateQuestionTree({
            nodes: undefined,
        }),
    );
};

export const fetchQuestionTree =
    ({ productServiceOid, diagnosisOid, payerId, prescriberNpi }) =>
    async (dispatch) => {
        try {
            const questionPayload = await getQuestionTree({
                productServiceOid,
                diagnosisOid,
                payerId,
                prescriberNpi,
            });
            const { nodes } = questionPayload;

            dispatch(
                updateQuestionTree({
                    nodes,
                }),
            );
        } catch (err) {
            handleError('An error occurred retrieving clinical policy.', err);
            dispatch(resetQuestionTree());
        }
    };
